'use client';

import { SyntheticEvent, useEffect, useState } from 'react';
import styles from './ToggleButton.module.css';

interface ToggleButtonProps {
  className?: string;
  list: Array<Record<string, any>>;
  defaultSelected?: number | null;
  selected?: string | number;
  disabled?: boolean;
}

export const ToggleButton = ({
  className,
  list,
  defaultSelected = 0,
  selected,
  disabled,
}: ToggleButtonProps) => {
  const [activeBtn, setActiveBtn] = useState(defaultSelected ?? 0);
  const handleClick = (e: SyntheticEvent, key: number) => {
    console.log(e);
    (e.target as HTMLButtonElement).scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
    setActiveBtn(key);
    if (list[key].onClick) list[key].onClick();
  };

  useEffect(() => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].value == selected) {
        setActiveBtn(i);
        break;
      }
    }
  }, [selected]);

  return (
    <div
      className={[styles.root, 'u-hide-scrollbar', className]
        .filter(Boolean)
        .join(' ')}
      data-disabled={disabled ? 'true' : undefined}
    >
      {list.map((element, index) => {
        return (
          <button
            disabled={disabled}
            key={index}
            className={index == activeBtn ? 'active gtm' : 'gtm'}
            data-buttontype="plan headers"
            data-product="Ultrahuman M1"
            onClick={(e) => handleClick(e, index)}
          >
            <span
              className={`btn-title ${
                element.redDot ? 'red-dot-active' : ''
              } ${element.newTag ? 'new-tag-active' : ''}`}
            >
              {element.title}
            </span>
          </button>
        );
      })}
    </div>
  );
};
